import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  connect() {
    this.loadPreferences()
  }

  loadPreferences() {
    // Charger les préférences depuis localStorage
    const hiddenChannels = this.getHiddenChannels()

    // Mettre à jour les checkboxes
    this.checkboxTargets.forEach(checkbox => {
      const isHidden = hiddenChannels.includes(checkbox.value)
      checkbox.checked = !isHidden

      // Ajouter l'effet visuel
      const label = document.querySelector(`label[for="${checkbox.id}"]`)
      if (label) {
        if (isHidden) {
          label.classList.add('opacity-50')
        } else {
          label.classList.remove('opacity-50')
        }
      }
    })
  }

  saveChannelPositions(event) {
    const positions = {}
    document.querySelectorAll('[data-channel-id]').forEach((element, index) => {
      const channelId = element.dataset.channelId
      positions[channelId] = index + 1
    })

    localStorage.setItem('tv_channel_positions', JSON.stringify(positions))
      }

  toggleChannel(event) {
    const checkbox = event.target
    const channelId = checkbox.value
    const hiddenChannels = this.getHiddenChannels()

    if (checkbox.checked) {
      // Retirer des chaînes cachées
      const updatedChannels = hiddenChannels.filter(id => id !== channelId)
      this.saveHiddenChannels(updatedChannels)
    } else {
      // Ajouter aux chaînes cachées
      const updatedChannels = [...hiddenChannels, channelId]
      this.saveHiddenChannels(updatedChannels)
    }

    // Déclencher l'événement pour mettre à jour le filtrage sur la page des programmes
    document.dispatchEvent(new CustomEvent('channelPreferencesChanged'))

    // Ajouter l'effet visuel
    const label = document.querySelector(`label[for="${checkbox.id}"]`)
    if (label) {
      if (checkbox.checked) {
        label.classList.remove('opacity-50')
      } else {
        label.classList.add('opacity-50')
      }
    }
  }

  getHiddenChannels() {
    try {
      const stored = localStorage.getItem('tv_hidden_channels')
      return stored ? JSON.parse(stored) : []
    } catch (e) {
      console.warn('Erreur lors de la lecture des préférences:', e)
      return []
    }
  }

  saveHiddenChannels(channels) {
    try {
      localStorage.setItem('tv_hidden_channels', JSON.stringify(channels))
    } catch (e) {
      console.warn('Erreur lors de la sauvegarde des préférences:', e)
    }
  }

  // Pour l'intégration avec le backend
  syncWithBackend() {
    const hiddenChannels = this.getHiddenChannels()

    // Envoyer au backend si nécessaire
    fetch('/settings/channels', {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.getCSRFToken()
      },
      body: JSON.stringify({
        hidden_channels: hiddenChannels
      })
    })
    .then(response => {
      if (response.ok) {
        }
    })
    .catch(error => {
      console.warn('Erreur de synchronisation:', error)
    })
  }

  getCSRFToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.getAttribute('content') : ''
  }
}